/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Footer_NoteInputs */

const en_platform_footer_note = /** @type {(inputs: Platform_Footer_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made for personal trainers and the people they train.`)
};

const pl_platform_footer_note = /** @type {(inputs: Platform_Footer_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrobione dla trenerów personalnych i ich podopiecznych.`)
};

/**
* | output |
* | --- |
* | "Made for personal trainers and the people they train." |
*
* @param {Platform_Footer_NoteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_footer_note = /** @type {((inputs?: Platform_Footer_NoteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Footer_NoteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_footer_note(inputs)
	return en_platform_footer_note(inputs)
});